<script setup>
import Preview  from '@/components/release_create/Preview.vue';
import Adoc from '@/components/release_create/AnalyzeDoc.vue';
import Freedialog from  '@/components/release_create/FreeDialog.vue';
import axios  from "axios";
import moment  from "moment";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-sheet>
            <v-dialog
                v-model="config_flg"
                width="500px"
            >
                <v-card
                >
                    <v-toolbar
                      dense
                      flat
                      tite
                      height="60px"
                      class="pb-2"
                      color="#E13533"
                      dark
                      z-index="1000000"
                    >
                        <v-toolbar-title>
                            宛名/署名設定
                        </v-toolbar-title>
                        <v-spacer>
                        </v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="view_list_mode"
                            >
                                    mdi-format-list-bulleted
                            </v-icon>
                            </template>
                            <span>一覧表示</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="add"
                            >
                                mdi-card-plus-outline
                            </v-icon>
                            </template>
                            <span>新規追加</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="config_flg=false"
                            >
                                mdi-close
                            </v-icon>
                            </template>
                            <span>閉じる</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-card-subtitle>
                        
                    </v-card-subtitle>
                    <v-card-text 
                        class="pb-1"
                         v-if="config_mode==true"
                    >
                        <v-radio-group
                          v-model="selected_conf_id"
                          column
                        >

                        <v-list>
                            <v-list-item
                                v-for="item in config_list"
                                v-bind:key="item.id"
                                class="pt-0 pb-0 pr-0 pl-0"
                                min-height="12px"
                            >
                                <v-card 
                                    width="100%"
                                    class="mb-2"
                                >
                                    <v-card-text
                                        class="pt-0 pb-0 pr-0 pl-0"
                                    >
                                        <v-container>
                                            <v-row>
                                            <v-col
                                                class="pr-0"
                                                cols = "1"
                                            >
                                            <v-radio
                                                color="red"
                                                :value="item.id"
                                                @click="set_conf_data"
                                            ></v-radio>
                                            </v-col>
                                            <v-col 
                                                class="pr-0 config_list_title_box"
                                            cols="9">
                                            <span>{{ item.config_name }}</span>
                                            </v-col>
                                            <v-col
                                                class="pl-0 pr-0"
                                            >
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-on="on"
                                                    v-bind="attrs"
                                                    class="mr-3"
                                                    :id="item.id"
                                                    @click="del"
                                                >
                                                    mdi-delete
                                                </v-icon>
                                                </template>
                                                <span>削除</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-on="on"
                                                    v-bind="attrs"
                                                    class="mr-3"
                                                    :id="item.id"
                                                    @click="conf_edit"
                                                >
                                                    mdi-pencil
                                                </v-icon>
                                                </template>
                                                <span>編集</span>
                                            </v-tooltip>
                                            </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-list-item>
                        </v-list>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-text 
                        class="pb-1"
                        v-if="config_mode==false "
                    >
                        <span v-if="config_list.length==0" class="zero_message"><v-icon color="blue">mdi-information-outline</v-icon>宛名/署名を作成してください。プレスリリースの共通項目として利用いたします。</span>
                        <v-text-field
                              clearable
                              placeholder="わかりやすい名前をつけて保存できます(例：商品説明用)"
                              hide-details="auto"
                              v-model="config_name"
                              :value = "config_name"
                                class="mb-2"
                              dense
                              outlined
                        ></v-text-field>
                        <v-text-field
                              clearable
                              placeholder="プレスリリースの宛名を入力してください(例：報道関係者各位)"
                              hide-details="auto"
                              v-model="direction"
                              :value = "direction"
                                class="mb-2"
                              dense
                              outlined
                        ></v-text-field>
                        <v-autocomplete
                            v-model="company_name"
                            :items="items"
                            :loading="isLoading"
                            :search-input.sync="search"
                            item-text="company_name"
                            item-value="id"
                            label="社名"
                            placeholder="社名を入力してください"
                            prepend-icon="mdi-database-search"
                            clearable    
                            return-object
                            @blur="text_check"
                        ></v-autocomplete>
                        <div v-if="company_name" style="margin:0 20px 15px">
                            <span v-if="company_name.id == '' || company_name.id == -1">Qlipper企業データベースとは紐づいていません。</span>
                            <span v-else>Qlipper企業データベースと紐づいています。</span>
                        </div>
                        <v-textarea
                              clearable
                              placeholder="プレスリリースの署名を入力してください(例：部署名 代表者氏名等)"
                              hide-details="auto"
                              v-model="signature"
                              :value = "signature"
                                dense
                                class="mb-2"
                              outlined
                        ></v-textarea>
                    <v-text-field
                          clearable
                          placeholder="※AI作成で利用する連絡先"
                          hide-details="auto"
                          v-model="contact"
                          :value = "contact"
                          outlined
                          dense
                          class="mb-2"
                    ></v-text-field>
                    <v-text-field
                          clearable
                          placeholder="※AI作成で利用する担当者"
                          hide-details="auto"
                          v-model="manager"
                          :value = "manager"
                          outlined
                          dense
                          class="mb-2"
                    ></v-text-field>
                    <v-text-field
                          clearable
                          placeholder="※AI作成で利用する事業内容"
                          hide-details="auto"
                          v-model="bizcontent"
                          :value = "bizcontent"
                          outlined
                          dense
                          class="mb-2"
                    ></v-text-field>
                    </v-card-text>
                    <v-card-actions class="pb-3" v-if="config_mode==false">
                        <v-spacer>
                        </v-spacer>
                        <v-btn
                            @click="config_flg=false"
                        >
                            cancel
                        </v-btn>
                        <v-btn
                            @click="config_save"
                            :disabled="config_save_flg"
                        >
                            保存
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="message_flg"
                width="500px"
            >
                <v-toolbar
                    tile
                    flat
                    height = "50px"
                    color="#E13533"
                    dark
                >
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="message_flg=false"
                            >
                                mdi-close
                            </v-icon>
                            </template>
                            <span>閉じる</span>
                        </v-tooltip>
                </v-toolbar>
                <v-card
                    tile
                    min-height="100px"
                >
                    <v-card-text class="pt-5">
                        {{ message }}
                    </v-card-text>
                </v-card>
            </v-dialog>
            <form action="https://docs.qlipper.jp/rel_file_gen.php" method="post" id="dl">
                <input type="hidden" name="title"  :value="title">
                <input type="hidden" name="stitle"  :value="sub_title">
                <input type="hidden" name="release_date_check" :value="release_date">
                <input type="hidden" name="release_date" :value="dsp_release_date">
                <input type="hidden" name="rsummary" :value="summary">
                <input type="hidden" name="rdoc" :value="e_doc">
                <input type="hidden" name="signature" :value="doc_signature">
                <input type="hidden" name="direction" :value="direction">
            </form>
            <v-menu
                v-model="analysis_flg"
                width = "500px"
                min-height= "300px"
                z-index = "100000"
                class="pl-2 pr-2"
                :close-on-content-click="fal"
            >
                <v-toolbar
                    dark
                    color="#E13533"
                >
                    <v-toolbar-title
                        height="50px"
                    >印象評価</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon
                        @click="analysis_flg=false"
                    >
                        mdi-close
                    </v-icon>
                </v-toolbar>
                <v-card
                    width="500px"
                    outlined
                    flat
                >
                    <v-card-text
                        class="analysis_mess"
                    >
                        キーワードの印象値は以下の要素で変化します。
                        <ul>
                            <li>ワードのユニークさ(変更不可)</li>
                            <li>ワード数</li>
                            <li>出現数</li>
                            <li>出現箇所(タイトルやサブタイトル、出現する行数)</li>
                            <li>強調</li>
                        </ul>
                    </v-card-text>
                </v-card>
                <v-card
                    width="500px"
                    max-height="calc(100vh - 400px)"
                >
                    <v-list>
                        <v-list-item
                            v-for="item in analysis_key"
                            v-bind:key="item.key"
                        >
                            <v-card
                                width="100%"
                            >
                                <v-card-text
                                    @click="check"
                                    :id="'pre-'+item.key"
                                >
                                        <v-row>
                                        <v-col 
                                            cols="10"
                                            :id="item.key"
                                        >
                                            <span class="analysis_key" :id="item.key">{{ item.key }}</span>
                                        </v-col>
                                        <v-col
                                            :id="item.key"
                                        >
                                            <span class="analysis_key" :id="item.key">{{ item.tfidf }}</span>
                                        </v-col>
                                        </v-row>
                                </v-card-text>
                            </v-card>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
    <v-dialog
        v-model="preview"
        z-index="100000000"
        fullscreen
        transition="dialog-bottom-transition"
        class="pf-5"

    >
        <v-sheet
            class="pl-3 pr-3"
        >
        <v-toolbar
            flat
            tile
            height="50px"
            color="#E13533"

        >
            <v-spacer></v-spacer>
            <v-btn
                @click="preview=false"
                dark
            >
                編集画面
            </v-btn>
        </v-toolbar>
        <v-row
            class="inner"
        >
            <v-col>
                <Adoc
                    :analysis_key="analysis_key"
                    v-on:word="analysis_word($event)"
                >
                </Adoc>
            </v-col>
            <v-col>
            <Preview
                :selected_word="selected_word"
            >
            </Preview>
            </v-col>
        </v-row>
        </v-sheet>
    </v-dialog>
    <Freedialog
        ref="free"
    >
    </Freedialog>

</v-sheet>
</template>
<script>
export default {
    data: () => ({
        pay_flg         : true,
        preview         : false,
        free_init_flg   : false,
        config_init_flg : false,
        config_mode     : true,
        config_flg      : false,
        config_save_flg : false,
        isLoading   : false,
        direction   : "",
        signature   : "",
        company_name : null,
        contact     : "",
        manager     : "",
        bizcontent  : "",
        search        : null,
        search_stop : false,
        entries     : [],
        config_name : "",
        config_id   : "",
        message_flg : false,
        message     : false,
        analysis_key : null,
        analysis_flg : false,
        fal          : false,
        config_list  : [],
        selected_word  : "",
        selected_conf_id : 0,
        selected_config : null,
        dsp_release_date : "",
        drawer: true,
        mini: true,
    }),
    computed : {
        items () {
          return this.entries.map(entry => {
            const company_name = entry.company_name;
            return Object.assign({}, entry, { company_name })
          });
        },
        doc_id : function() {
            return this.$store.getters['doc_info/get_doc_id'];
        },
        title : function() {
            return this.$store.getters['doc_info/get_title'];
        },
        sub_title : function() {
            return this.$store.getters['doc_info/get_subtitle'];
        },
        summary : function() {
            return this.$store.getters['doc_info/get_summary'];
        },
        doc_signature : function(){
            return this.$store.getters['doc_info/get_signature'];
        },
        e_doc : function() {
            return this.$store.getters['doc_info/get_doc'];
        },
        schedule_id : function() {
            return this.$store.getters['doc_info/get_schedule_id'];
        },
        release_date : function() {
            let date_str = this.$store.getters['doc_info/get_release_date'];
            
            if(date_str != "" && date_str != null)
            {
                this.dsp_release_date = moment(date_str).format("YYYY年MM月DD日");
            }
            return date_str;
        },
        _init_flg : function(){
            return [this.free_init_flg,this.config_init_flg];
        },
    },
    watch : {
		config_list : function(){
			if(this.config_list.length==0)
			{
				this.add();
			}
		},
        search (val) {
            if(this.search_stop == true)
            {
                this.search_stop = false;
                return;
            }
            if (val == "")
            {
                return ;
            }
              if (this.isLoading) return;
              clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.search_company(val);
            }, 500);
        },
        _init_flg : function(){
            if(this.free_init_flg == true && this.config_init_flg == true)
            this.$emit("configload");
        },
        anaisis_flg : function(){
            if(this.analysis_flg==true)
            {
                this.$nextTick(function(){
                    let elem  = document.querySelector(".v-menu__content");
                    elem.style.position="fixed";
                    elem.style.top="80px";
                    elem.style.left="100px";
                });
            }
            if(this.selected_word == "")
                return ;
            const before_elem = document.getElementById('pre-'+this.selected_word);
            if(before_elem != undefined)
                before_elem.style.backgroundColor="";
            this.selected_word = "";
        },
        config_mode : function(){
            if(this.config_mode == true)
            {
                this.config_load();
            }
        },
        config_name : function(){
            this.config_save_flg = this.config_write_check();
        },
        direction  : function(){
            this.config_save_flg = this.config_write_check();
        },
        signature : function(){
            this.config_save_flg = this.config_write_check();
        },
        config_flg : function(){
            if(this.config_flg==true)        
            {
                this.config_mode=true;
            }
        },
    },
    methods: {
        analysis_word : function(data){
            this.selected_word = data.word;
        },
        gpt : function(){
            this.$refs.gpt.open();
        },
        search_company : async function(val) {
          this.isLoading = true;
          var params = new URLSearchParams();
          params.append("query",val);
          await axios.post("/api/release/get_company",params)
          .then(response => {
              this.entries = response.data;
              this.isLoading = false;
              if(this.company_name != null)
              {
                    // 変更されたならIDは消す    
                    //this.company_name.id=-1;
              }
          });
        },
        text_check : function(data){
            if(data.target.value != "")
            {
                if(this.company_name == null || (this.company_name != null && this.company_name.id == -1))
                {
                    this.search_stop=true;
                    this.entries = [];
                    this.entries = [{company_name : data.target.value , id : -1},];
                    this.company_name = {company_name : data.target.value , id : -1};
                }
            }
        },
        set_conf_data : function(){
            this.selected_config = this.config_list[this.get_config(this.selected_conf_id)];
            if(this.selected_conf_id == 0)
            {
                this.selected_conf_id = this.selected_config.id;
            }
            if(this.selected_config != undefined)
            {
                let signature = this.selected_config.signature;
                if(this.selected_config.company_name != "" && this.selected_config.company_name != null)
                {
                    signature = this.selected_config.company_name + "\n" + this.selected_config.signature;
                }
            
                this.$store.commit("doc_info/set_config",{
                    "direction" : this.selected_config.direction,
                    "signature" : signature,
                    "conf_id"   : this.selected_config.id,
                });
            }
        },
        config_write_check : function(){
            if(this.config_name!="" && this.direction!="" && this.signature!="")
                return false;
            return true;
        },
        config_save : async function(){
            var params = new URLSearchParams();
            params.append("direction",this.direction);
            params.append("signature",this.signature);
            params.append("config_name",this.config_name);
            params.append("manager",this.manager);
            params.append("contact",this.contact);
            params.append("bizcontent",this.bizcontent);
            if(this.company_name != null)
            {
                params.append("company_name",this.company_name.company_name)
                params.append("company_id",this.company_name.id)
            }
            params.append("id",this.config_id);
            await axios.post("/api/release/set_config",params)
            .then(response => {
                this.config_id  = response.data.id;
                this.selected_conf_id = this.config_id;
				this.config_load();
                this.config_mode = true;
            });
        },
        config_load : async function(){
            var params = new URLSearchParams();
            await axios.post("/api/release/get_config",params)
            .then(response => {
                this.config_list  = response.data;
                this.config_init_flg = true;
                if(this.config_list.length == 0)
                {
                    this.config_mode=false;
                }
                else
                {
                    this.set_conf_data();
                }
            });
        },
        save_doc : async function(){
            if(this.title == "" || this.title == null)
            {
                this.message = "タイトルが入力されていません。タイトルは必須項目です";
                this.message_flg=true;
                return ;
            }

            var params = new URLSearchParams();
            params.append("title",this.title);
            params.append("sub_title",this.sub_title);
            params.append("summary",this.summary);
            params.append("doc",this.e_doc);
            params.append("conf_id",this.selected_conf_id);
            params.append("schedule_id",this.schedule_id);
            params.append("release_date",this.release_date);
            params.append("id",this.doc_id);
            await axios.post("/api/release/save_doc",params)
            .then(response => {
                this.$store.commit("doc_info/set_doc_id",response.data.id);
                // doc_id の存在チェックをして通知する
                // スケジュールIDの存在チェックをして通知する
                if(response.data.schedule_id != undefined)
                    this.$store.commit("doc_info/set_schedule_id",response.data.schedule_id);


                this.message = "保存しました";
                this.message_flg=true;
            })
              .catch((error) => {
                console.error('失敗です', error);
              });
        },
        add      : function(){
            this.direction   = "";
            this.signature   = "";
            this.config_name = "";
            this.contact = "";
            this.manager = "";
            this.bizcontent = "";
            this.config_name = "";
            this.config_id   = "";
            this.config_mode=false;
            this.entries = [];
            this.company_name = null;
        },
        del : async function(event){
            if(event.target.id == this.selected_conf_id)
            {
                if(!window.confirm("IDが選択されています。削除してよろしいですか？"))
                {
                    return false;
                }
            }

            var params = new URLSearchParams();
            params.append("id",event.target.id);
            await axios.post("/api/release/del_config",params)
            .then(response => {
                this.config_list  = response.data;
            });
            
        },
        analysis : async function(){
            if(this.title == "" || this.title == null)
            {
                this.message = "タイトルが入力されていません。タイトルは必須項目です";
                this.message_flg=true;
                return ;
            }
            let params = {
                'title' : this.title,
                'stitle': this.sub_title,
                'rsummary':this.summary,
                'rdoc':this.e_doc,
            };
            await axios.post("/api/release/word_check",params)
            .then(response => {
                this.analysis_key=response.data;
                //this.analysis_flg=true;
            });
        },
        download : async function(){
            /*
            if(this.pay_flg!=true)
            {
                this.$refs.free.open();
                return;
            }
            */

            if(this.title == "" || this.title == null)
            {
                this.message = "タイトルが入力されていません。タイトルは必須項目です";
                this.message_flg=true;
                return ;
            }
            window.onbeforeunload = null;    
            let elem = document.getElementById("dl");
            await elem.submit();
        },
        config   : function(){
            /*
            if(this.pay_flg==true)
            {
                this.config_flg=true;
            }
            else
            {
                this.$refs.free.open();
            }
            */
            this.config_flg=true;
        },
        view_list_mode : function(){
            this.config_mode=true;
        },
        get_config : function(id){
            let index = 0;
            if(id==0)return index;
            for(;index<this.config_list.length;index++)
            {
                if(this.config_list[index].id == id)
                {
                    break;
                }
            }
            return index;
        },
        conf_edit : function(event){
            this.config_mode=false;
            this.search_stop = true;
            let index = this.get_config(event.target.id);
            this.direction=this.config_list[index].direction;
            this.signature=this.config_list[index].signature;
            this.config_name=this.config_list[index].config_name;
            this.contact=this.config_list[index].contact;
            this.manager=this.config_list[index].manager;
            this.bizcontent=this.config_list[index].bizcontent;
            this.config_id=this.config_list[index].id;

            // autocomplete obj
            if( this.config_list[index].company_name != null && this.config_list[index].company_name != "")
            {
                if(this.config_list[index].company_id == null)
                    this.config_list[index].company_id = -1;
    
                this.entries      = [{company_name : this.config_list[index].company_name,id : this.config_list[index].company_id},];
                this.company_name = {company_name : this.config_list[index].company_name,id : this.config_list[index].company_id};
            }
            else
            {
                this.entries=[];
                this.company_name=null;
            }
        },
        check    : function(event){
            const elem = document.getElementById('pre-'+event.target.id);
            if(event.target.id.indexOf('pre-') >= 0)
                return;

            if(this.selected_word != "")
            {
                const before_elem = document.getElementById('pre-'+this.selected_word);
                if(before_elem != undefined)
                    before_elem.style.backgroundColor="";
            }
            this.selected_word = event.target.id;
            elem.style.backgroundColor="#FDF0F0";
        },
        relmng   : function(){
            if(this.pay_flg!=true)
            {
                this.$refs.free.open();
                return;
            }
            location.href="/relmng";
        },
        preview_open : function(){
            this.preview=true;
            this.analysis();
        },
    },
    created : function(){
        if(this.$store.getters['doc_info/get_conf_id'] != "")
        {
            this.selected_conf_id = this.$store.getters['doc_info/get_conf_id'];
            this.direction        = this.$store.getters['doc_info/get_direction'];
            this.signature        = this.$store.getters['doc_info/get_signature'];
        }
		this.config_load();
    },
    mounted : function(){

    },
}
</script>
<style>
.first_message{
    display:block;
    margin-bottom: 20px;
    color:#a22041;
}
</style>
